import './new-transport-type.scss';

import HeaderContent from "@shared/ui/header-content/header-content";
import { Button } from "primereact/button";
import { FormProvider } from "react-hook-form";
import { FaChevronLeft } from "react-icons/fa6";

import FormTransportType from "../form-transport-type/form-transport-type";
import { useNewTransportType } from './new-transport-type.hook';

export function NewTransportType() {  
  const {
    isCreating,
    formMethod,
    navigate,
    handleSubmit,
    handleValidate,
    handleValidateError,
  } = useNewTransportType();

  return (
    <div id="NewTransportType" className="transport-type">
      <HeaderContent
        title={<h1>New Transport Type</h1>}
        backIcon={<FaChevronLeft />}
        onBack={() => navigate("../")}
      >
        <Button
          className="w-full block"
          label="Save"
          disabled={isCreating}
          onClick={handleSubmit(handleValidate, handleValidateError)}
        ></Button>
      </HeaderContent>

      <div className="p-7">
        <FormProvider {...formMethod}>
          <section className="grid grid-cols-1 md:grid-cols-2 gap-2 mb-4">
            <FormTransportType />
          </section>
        </FormProvider>
      </div>
    </div>
  );
}

export default NewTransportType;